'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { getAlwaysShowFinderOnStartup, shouldUpdatePreviewer } from 'DesignData/selectors/app';
import { setAlwaysShowFinderOnStartup, setUpdatePreviewer } from 'DesignData/actions/Application';
import GeneralComponent from 'DesignManagerIde/components/settings/General';

const mapStateToProps = (state, props) => {
  return {
    alwaysShowFinderOnStartup: getAlwaysShowFinderOnStartup(state, props),
    updatePreviewer: shouldUpdatePreviewer(state, props)
  };
};

const mapDispatchToProps = {
  setAlwaysShowFinderOnStartup,
  setUpdatePreviewer
};

function General(props) {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "GENERAL_SETTINGS",
    children: /*#__PURE__*/_jsx(GeneralComponent, {
      alwaysShowFinderOnStartup: props.alwaysShowFinderOnStartup,
      setAlwaysShowFinderOnStartup: props.setAlwaysShowFinderOnStartup,
      updatePreviewer: props.updatePreviewer,
      setUpdatePreviewer: props.setUpdatePreviewer,
      registerToolbarContent: props.registerToolbarContent
    })
  });
}

General.propTypes = {
  alwaysShowFinderOnStartup: PropTypes.bool.isRequired,
  setAlwaysShowFinderOnStartup: PropTypes.func.isRequired,
  updatePreviewer: PropTypes.bool.isRequired,
  setUpdatePreviewer: PropTypes.func.isRequired,
  registerToolbarContent: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(General);